import { render, staticRenderFns } from "./ProductStoreInfo.vue?vue&type=template&id=67711024"
import script from "./ProductStoreInfo.vue?vue&type=script&lang=js"
export * from "./ProductStoreInfo.vue?vue&type=script&lang=js"
import style0 from "./ProductStoreInfo.vue?vue&type=style&index=0&id=67711024&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports